import "../styles/main_page.scss";
import { useRef } from "react";
import { Logo } from "../components/logo";
import { logos, items, brands, data } from "../services/data.ts";
import Slider from "../components/slider";
import Objectives from '../components/objectives.jsx';
import Contact from "../components/contact.jsx";
import Services from "../components/services.jsx";

const Main = () => {
  return (
    <>
{      window.scrollTo({ top: 0, behavior: 'smooth' })}

      <section className="main-container">
        <div className="hero-section">
          <div className="hero-content">
            {/* Main Title Group */}
            <div className="hero-text-container">
              <h1 className="hero-title">
                <span className="pre-title">Assistência especializada em</span>
                Relógios de luxo e <p /> Alta relojoaria
              </h1>
              <p className="hero-subtitle">
                <span>{items.desc[0] + items.years + items.desc[1]}</span>
              </p>
            </div>
          </div>
        </div>

        <Slider brands={brands} />
        <Services />
        <Objectives />
        <Contact />
      </section>
    </>
  );
};

export default Main;